// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__aR5zn","range":"MonthRangeSwitch_range__2vtkB","disabled":"MonthRangeSwitch_disabled__2U5_T"};